<template>
  <div class="w-full sm:w-1/1 md:w-3/5 lg:w-3/5 px-2 mb-3 flex flex-col overflow-y-auto max-h-[640px]">
    <div class="p-6 bg-[#121212] rounded-lg w-full shadow-2xl bg-base-100 lg:text-left ">
      <div class="tax-page">
        <h3 class="page-title">НӨАТ-ын баримтын түүх</h3>
        <div v-if="taxList.length > 0"
             class="tax-list grid gap-2 lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 grid-cols-1">
          <e-barimt-item v-for="item in taxList" :key="item.id" :tax-data="JSON.parse(item.tax_obj)" :multi="true"/>
        </div>
        <p v-else class="empty">Одоогоор мэдээлэл байхгүй
          байна.</p>
      </div>
    </div>
  </div>
</template>

<script>
import EBarimtItem from "../components/EBarimtItem.vue";
import api from "@store/_boot/baseApi";
import {mapGetters} from "vuex";

export default {
  name: "Ebarimt",
  components: {EBarimtItem},
  data() {
    return {
      isLoading: false,
      taxList: []
    }
  },
  created() {
    this.getTaxList();
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    getTaxList() {
      this.isLoading = true;
      api.get('/api/receipt/list', {
        params: {
          'user_id': this.user.id,
        }
      }).then(({data}) => {
        console.log("data--->", data);
        this.taxList = data;
        this.isLoading = false;
      }).catch(e => {
        console.log(e);
        this.isLoading = false;
      })
    }
  }
}
</script>
